<template>
  <section class="tc-feat" aria-labelledby="tu-construye-features-title">
    <span class="tc-feat__tag">Características exclusivas</span>

    <div class="tc-feat__heading">
      <h2 id="tu-construye-features-title" class="wd-title">
        <span class="tc-feat__base">Tus características</span> <span class="hl">exclusivas</span>
      </h2>
      <p class="wd-body">Nosotros te acompañamos en cada paso para que la construcción de tu futuro sea segura y accesible.</p>
    </div>

    <ul class="tc-feat__grid">
      <li v-for="feature in features" :key="feature.title" class="tc-feat__card">
        <div class="tc-feat__head">
          <img :src="feature.icon" alt="" aria-hidden="true">
          <h3 class="tc-feat__title">{{ feature.title }}</h3>
        </div>
        <p class="wd-body" v-html="feature.description" />
      </li>
    </ul>
  </section>
</template>

<script setup lang="ts">
import alcanceIcon from '../../../assets/tu-construye-figma/ic-alcance.svg'
import montosIcon from '../../../assets/tu-construye-figma/ic-montos.svg'
import garantiaIcon from '../../../assets/tu-construye-figma/ic-garantia.svg'
import flexibleIcon from '../../../assets/tu-construye-figma/ic-flexible.svg'
import inicioIcon from '../../../assets/tu-construye-figma/ic-inicio.svg'

const features = [
  {
    icon: alcanceIcon,
    title: 'Alcance',
    description: 'Exclusivo para construcción <br>o terminación de obra <br>(no remodelación).'
  },
  {
    icon: montosIcon,
    title: 'Montos',
    description: 'Financiamiento desde <br class="br-tm">$250 mil hasta $15.0M'
  },
  {
    icon: garantiaIcon,
    title: 'Tu garantía',
    description: 'Usamos tu terreno como respaldo. Solo necesitamos <br class="br-d">que su valor sea igual o mayor a la tercera parte de lo que <br class="br-d">vas a contratar.'
  },
  {
    icon: flexibleIcon,
    title: 'Financiamiento Flexible',
    description: 'Te financiamos el 67% del monto total en ministraciones. Y lo mejor: al terminar, el valor de tu casa ampara el 100% <br class="br-d">de lo contratado.'
  },
  {
    icon: inicioIcon,
    title: 'Inicio Tranquilo',
    description: 'Tienes 3 meses de prórroga <br class="br-m">antes de empezar tu primer <br class="br-m">pago completo.'
  }
]
</script>

<style scoped>
.tc-feat { display: flex; flex-direction: column; align-items: flex-start; gap: var(--ds-space-7); }

.tc-feat__tag {
  display: inline-flex;
  align-items: center;
  padding: var(--ds-space-3);
  border-radius: 9999px;
  background: var(--ds-tag-orange-fill);
  color: var(--ds-tag-orange-text);
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
}

/* Título y texto de apoyo: 8px entre sí, 40px respecto a las demás piezas */
.tc-feat__heading { display: flex; flex-direction: column; gap: var(--ds-space-3); width: 100%; }
.tc-feat__heading .wd-body { min-height: 32px; }
.tc-feat__base { color: var(--ds-purple-900); }
.tc-feat .wd-title { line-height: 44px; }

.tc-feat__grid {
  display: grid;
  grid-template-columns: repeat(6, minmax(0, 1fr));
  gap: var(--ds-space-5);
  width: 100%;
  margin: 0;
  padding: 0;
  list-style: none;
}
.tc-feat__card { grid-column: span 2; }

.tc-feat__card {
  display: flex;
  flex-direction: column;
  gap: var(--ds-space-4);
  /* El borde de 1px va dentro de las medidas del Figma (24px de padding incluyendo el trazo) */
  padding: calc(var(--ds-space-5) - 1px);
  box-sizing: border-box;
  background: var(--ds-grey-50);
  border: 1px solid var(--ds-border-card);
  border-radius: 16px;
}

.tc-feat__head { display: flex; align-items: center; gap: var(--ds-space-4); }
.tc-feat__head img { flex: 0 0 40px; width: 40px; height: 40px; }
.tc-feat__title {
  margin: 0;
  color: var(--ds-text-body);
  font-size: 18px;
  font-weight: 600;
  line-height: normal;
}

@media (max-width: 1024px) {
  .tc-feat__heading .wd-body { min-height: 0; }
  .tc-feat__grid { grid-template-columns: repeat(2, minmax(0, 1fr)); }
  .tc-feat__card { grid-column: auto; }
  .tc-feat__card:last-child { grid-column: span 2; }
}

@media (max-width: 599px) {
  .tc-feat__grid { grid-template-columns: minmax(0, 1fr); }
  .tc-feat__card:last-child { grid-column: auto; }
}
</style>
